export class mdlPaymentDetailsRes_DH{
    public RegNo: string;
    public ProposalNo: string;
    public Email: string;
    public EPayInfo: string;
    public EProposalNo: string;
    public Name: string;
    public Mobile: string;
    public PaySig: string;
    public ProductCode: string;
    public TotalPremium: number;
    public StatusCode: string;
    public StatusDesc: string;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlPaymentDetailsRes_DH.ts